// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f854a617","703":"203d10fa","787":"0cbbea16"}[chunkId] + ".chunk.js";
};